import { useAppSelector } from '../hooks';
import { type RootState } from '../store';
import { selectDeployments, type IDeployment } from '../reducers/deploymentsSlice';

export const useDeployments = (): { deployments: IDeployment[] } => {
  const deployments = useAppSelector((state: RootState) => selectDeployments(state)) ?? [];

  return { deployments };
};
